import * as React from 'react'

import { Tooltip } from '../../Shared/index'

const menuIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/s/reorder.svg`
const closeIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/xs/remove.svg`

export const REOPEN_TOOLTIP_TEXT = 'Click here to re-open the teacher preview menu, allowing you to jump between questions.'
export const CLOSE_TOOLTIP_TEXT = 'Close the teacher preview menu.'

interface TeacherPreviewToggleProps {
  previewShowing: boolean;
  onTogglePreview: () => void;
}

// One Tooltip across both states rather than a branch per state. Swapping between a wrapped and an
// unwrapped button unmounts the node the keyboard is standing on, so opening the menu dropped focus
// to the body -- and Evidence hides the menu's own close button, so there was no quick way back.
//
// isTabbable is off because the trigger is already a button: left tabbable the wrapper takes the
// first Tab and swallows it, since Enter on a span does nothing. It also moves aria-describedby
// onto the button, which is the element that actually receives focus.
const TeacherPreviewToggle = ({ previewShowing, onTogglePreview, }: TeacherPreviewToggleProps) => (
  <div className="teacher-preview-toggle">
    <Tooltip
      closeOnTriggerClick={true}
      hugContent={true}
      isTabbable={false}
      mode="dark"
      tooltipText={previewShowing ? CLOSE_TOOLTIP_TEXT : REOPEN_TOOLTIP_TEXT}
      tooltipTriggerText={(
        <button
          aria-expanded={previewShowing}
          aria-label={previewShowing ? 'Close teacher preview menu' : 'Open teacher preview menu'}
          className="quill-button small outlined white focus-on-dark"
          onClick={onTogglePreview}
          type="button"
        >
          <img alt="" src={previewShowing ? closeIconSrc : menuIconSrc} />
        </button>
      )}
    />
  </div>
)

export default TeacherPreviewToggle
